/**
 * UranIA PA — Ambiente immersivo (`/immersivo`): «Da dove partiamo» → editor.
 *
 * Due fasi, una sola rotta (vedi `ImmersivoPage`). Guardia restrittiva di
 * proposito: redige atti solo chi ne ha titolo (`funzionario_adg`,
 * `platform_admin` — non `beneficiario_ri`, non l'auditor quando esisterà,
 * vedi `lib/ruoli.ts`).
 */

import { createRoute } from '@tanstack/react-router';

import { ImmersivoPage } from '../features/immersivo/ImmersivoPage.tsx';
import { ruoloCorrente } from '../lib/auth/ruolo-corrente.ts';
import { guardia } from '../lib/ruoli.ts';
import { Route as ServiziSegmentRoute } from './_servizi.tsx';

export const Route = createRoute({
  getParentRoute: () => ServiziSegmentRoute,
  path: '/immersivo',
  beforeLoad: () => guardia('/immersivo', ruoloCorrente()),
  component: ImmersivoPage,
});
